const NAME = "HOLIDAY_TABLE";

export default NAME;
